const extractImagesFromMarkdown = (markdown?: string): string[] => {
    if(!markdown) {
        return [];
    }

    const imageUrls: string[] = [];
    const ncoreImageRegex = /\[image\]\(([^)]+)\)(?:<[^>]*>)?(?:--[^-]*--)?/g;
    let match: RegExpExecArray | null;

    while((match = ncoreImageRegex.exec(markdown)) !== null) {
        if(match[1] && !imageUrls.includes(match[1])) {
            imageUrls.push(match[1]);
        }
    }

    const standardImageRegex = /!\[[^\]]*\]\(([^)]+)\)/g;

    while((match = standardImageRegex.exec(markdown)) !== null) {
        if(match[1] && !imageUrls.includes(match[1])) {
            imageUrls.push(match[1]);
        }
    }

    return imageUrls;
};

const stripMarkdownForInstagram = (markdown?: string): string => {
    if(!markdown) {
        return "";
    }

    let cleaned = markdown;

    cleaned = cleaned.replace(/\[image\]\([^)]+\)(?:<[^>]*>)?(?:--[^-]*--)?/g, "");
    cleaned = cleaned.replace(/\[button\]\(([^)]+)\)<([^>]*)>/g, "$2: $1");
    cleaned = cleaned.replace(/!\[[^\]]*\]\([^)]+\)/g, "");
    cleaned = cleaned.replace(/```[\s\S]*?```/g, "");
    cleaned = cleaned.replace(/`([^`]+)`/g, "$1");
    cleaned = cleaned.replace(/^#{1,6}\s+(.+)$/gm, "📢 $1");
    cleaned = cleaned.replace(/\*\*([^*]+)\*\*/g, "$1");
    cleaned = cleaned.replace(/\*([^*]+)\*/g, "$1");
    cleaned = cleaned.replace(/__([^_]+)__/g, "$1");
    cleaned = cleaned.replace(/_([^_]+)_/g, "$1");
    cleaned = cleaned.replace(/\[([^\]]+)\]\([^)]+\)/g, "$1");
    cleaned = cleaned.replace(/^>\s+(.+)$/gm, "$1");
    cleaned = cleaned.replace(/^[*\-+]\s+(.+)$/gm, "• $1");
    cleaned = cleaned.replace(/\n{3,}/g, "\n\n");

    return cleaned.trim();
};

export {
    stripMarkdownForInstagram,
    extractImagesFromMarkdown
};
